import { styled } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

export const CalendarIcon = styled(CalendarTodayIcon)({
  width: "16px",
  height: "16px",
  color: "#646D7B"
});
